import Vue from 'vue'
import Element from 'element-ui/lib/element-ui.common'
import hoverDelay from './hoverDelay'
import modal from './modal'

Vue.directive('hover-delay', hoverDelay)

export default () => {
  Vue.use(Element, {  size: 'small' })
}

// 创建事件总线
Vue.prototype.$bus = new Vue();
// 模态框对象
Vue.prototype.$modal = modal

// 预请求svg组件(通过之前的svg-sprite-loader加载)
const req = require.context('@/assets/icons/svg', true, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
